export default {
    newDesign: true,
    title: "Motivasyonu yüksek ailelere özel burs ve indirim fırsatları | Kodland",
    downtimeUrl: "https://www.kodland.org/tr",
    parameters: {
        landing_id: "TrQGtsD",
        segment: 52,
        fb_pixel: 1272902257531593,
    },
    startPage: {
        title:
            "Motivasyonu yüksek ailelere özel burs ve indirim fırsatları",
        subtitle:
            "Kaliteli eğitimin herkes için erişilebilir olması gerektiğine inanıyoruz",
        image: {
            url: "/welcome/tr_gts_d_desk.png", 
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/tr_gts_d_mob.png",
            style: {
                width: "100%",
            },
        },
        button: " Hadi Başlayalım! 🚀 ", //меняем?
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
    },
    quizRotateBySteps: {
        1: {
            question: "Çocuğunuz okulda en çok hangi derslerde başarılı oluyor? 🎓",
            answers: [
                "🧮 Matematik ve Fen Bilimleri",
                "📘 Dil Dersleri (Türkçe ve yabancı dil)",
                "📕 Din Kültürü ve Tarih",
                "Diğer"
            ],
        },
        2: {
            question: "Çocuğunuz yeni nesil sorularla mücadele ediyor mu?",
            answers: [
                "😢 Evet, zor görünüyorlar",
                "😐 Genel olarak anlar, ancak bazı zorluklar yaşar",
                "🌟 Hayır, yeni nesil soruları iyi anlıyorlar"
            ],
        },
        3: {
            question: "Çocuğunuz daha önce bir deneme LGS sınavına girdiyse, tüm derslerden toplam kaç puan aldı?",
            answers: [
                "😢 100-250",
                "😐 251-350",
                "🌟 351-500",
                "❌ Bilmiyorum (LGS denemesine girmek istiyorum)"
            ],
        },
        4: {
            question: "Çocuğunuz için en zor konular hangileri?",
            answers: [
                "🌀 İrrasyonel ifadeler",
                "⚖️ Cebirsel ifadeler ve eşitsizlikler",
                "📏 Doğrusal denklemler",
                "🤔 Bilmiyorum (bulmama yardım edin)"
            ],
        },
        5: {
            title: "Çocuğunuzun Yaşını Seçin",
            subtitle: "Uzman öğretmenlerimiz, çocuğunuzun matematik özgüveni kazanmasını ve okul performansını artırmasını sağlar.",
            type: "age",
            button: "",
        },
        6: {
            question:
                "Çocuğunuzun çalışması için bir masaüstü veya dizüstü bilgisayarınız var mı?",
            answers: [
                "👍 Evet",
                {
                    answer: "👎 Hayır",
                    stopAnswer: true,
                },
            ],
        },
        7: {
            title: "ÜCRETSİZ LGS Matematik deneme dersiniz için bir tarih seçin",
            typeInfo: "congrats",
            subtitle:
                "Çocuğunuzun LGS puanını artıracak verimli ve katılımcı bir deneyim için yerinizi ayırtın!",
            button: "📅 Ücretsiz Dersimi Planla",
        },
        8: {
            title: "Ücretsiz ders rezervasyonu yapın",
            type: "one-page-contacts",
            subtitle: "",
            button: "Neredeyse bitti 🔥",
        },
        9: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        10: {
            title:
                "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Lütfen not edin:<br>• Çalışan bir bilgisayar veya dizüstü gerekli.<br>• Ders sırasında ebeveyn bulunmalı.<br>• Dersler, özgüveni ve matematik başarısını artırmak için kişiselleştirilmiştir.Adım adım matematik zorluklarını aşalım!",
            button: "Sırada ne var?",
        },
        11: {
            title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
            button: "Başka neler var?",
        },
        12: {
            title: "Ders platformumuzda gerçekleşecek 💻",
            typeInfo: "classroom",
            subtitle:
              "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
            button: "Anladım ✅",
        }
    },
};